var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{attrs:{"expand":"","dense":"","nav":""}},_vm._l((_vm.allowedRoutes),function(route){return _c('menu-route-item',{key:route.path,attrs:{"route":route,"disabled":route.disabled}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }